<template>
  <!-- -->
  <div class="echart-map">
    <span style="position: absolute;right: 0;top: 0;color: #FFF;z-index: 99;cursor: default" v-if="adCode !== rootAdCode" @click="toParent">返回</span>
    <div class="map-container"  ref="chartsDOM"/>
    <board-data-card @mouseenter="stopHide" @mouseleave="hideWindowInfo" class="site-info" :class="showWindowInfo? 'show': 'hide'" line-color="#3f99fa" :label="data.siteName" type="simple">
      <div class="site-info-item">
        <div class="info-line">
          <div class="info-name">工地名称</div>
          <div class="info-value">{{data.siteName}}</div>
        </div>
        <div class="info-line">
          <div class="info-name">工地地址</div>
          <div class="info-value">{{data.siteAddr}}</div>
        </div>
        <div class="info-line">
          <div class="info-name">负责人</div>
          <div class="info-value">{{data.leaderName}}</div>
        </div>
        <div class="info-line">
          <div class="info-name">当前状态</div>
          <div class="info-value">{{data.status === 0? "未开始": "进行中"}}</div>
        </div>
        <div class="info-line" v-if="data.actualStartTime">
          <div class="info-name">开始时间</div>
          <div class="info-value">{{data.actualStartTime}}</div>
        </div>
        <div class="info-line" v-if="data.actualStartTime">
          <div class="info-name">施工进度</div>
          <div class="info-value">{{data.progress}}%</div>
        </div>
        <div class="info-button">
          <table-button @click="windowOpen(`/project/site/detail?id=${data.id}`)">查看详情</table-button>
        </div>
      </div>
    </board-data-card>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import * as echarts from "echarts";
import geoApi from "@/api/normal/sys/geoApi"; // 使用阿里云的geo
import BoardDataCard from "@/components/h5/board/BoardDataCard.vue";
import {markRaw} from "vue";
import TableButton from "@/components/h5/button/TableButton.vue";

export default {
  props: {
    // 显示地图的标记点颜色，两个颜色分别是未选中和已选中
    markerColor: {default: () => ["pink", "red"]}
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "EMap",
  components: {
    TableButton,
    BoardDataCard
  },
  data() {
    return {
      myChart: null,
      geoDataList: [], // 地图图形数据
      adCode: "",
      rootAdCode: "510000",
      showWindowInfo: false,
      hideTimeout: "",
      markerList: [],
      data: {

      }
    };
  },
  created() {
  },
  mounted() {
    this.init();
  },
  unmounted() {
    if (this.myChart) {
      this.myChart.dispose();
    }
  },
  methods: {
    windowOpen(url) {
      this.router.push(url);
    },
    // 鼠标移入窗口信息
    stopHide() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }
    },
    // 隐藏窗口信息
    hideWindowInfo() {
      this.hideTimeout = setTimeout(() => {
        this.showWindowInfo = false;
      }, 500);
    },
    toParent() {
      let code = this.adCode + "";
      // 返回上一级
      if (code.endsWith("0000")) {
        // 4个0是省
        this.showMap("100000");
      } else if (code.endsWith("00")) {
        // 2个0是市
        this.showMap(code.substring(0, 2) + "0000");
      }
    },
    init() {
      this.showMap(this.rootAdCode); // 显示全国地图
      // 点击事件
      this.myChart.on('click', (params) => {
        if (params.componentType === "markPoint") {
          // 点击的是地图上的点
          this.showWindowInfo = true;
          this.data = params.data; // 显示信息
          this.showMarkerSelect(params.data);
        } else if (params.componentType === "series") {
          // 点击的是地图上的区域
          // this.chartClick(params.data);
        }
      })
      this.myChart.on("globalout", this.hideWindowInfo);
    },
    // 选中某个点
    showMarkerSelect(data) {
      for (let i = 0; i < this.markerList.length; i++) {
        if (data.id === this.markerList[i].id) {
          this.markerList[i].itemStyle.color = this.markerColor[1];
        } else {
          this.markerList[i].itemStyle.color = this.markerColor[0];
        }
      }
      this.showMap(this.adCode); // 重新渲染
    },
    // 添加地图标记点,arr: [{name: "工地名称", id: "111", value: "宜金高速01", coord: [103.965819, 30.988301]}]
    setMarkerList(arr) {
      if (!this.myChart) {
        // 初始化未完成
        setTimeout(() => this.setMarkerList(arr), 100);
        return;
      }
      let markerList = [];
      for (let i = 0; i < arr.length; i++) {
        markerList.push({
          ...arr[i],
          symbolSize: 20, label: {show: false}, itemStyle: { color: this.markerColor[0]}
        })
      }
      this.markerList = markerList; // marker信息
      this.showMap(this.rootAdCode); // 重新渲染
    },
    // 显示某个区域的地图
    showMap(adCode) {
      if (adCode === this.adCode) {
        this.refreshEcharts(adCode);
        return;
      }
      if (this.myChart) { // 如果有数据，就清空，否则会因为平移缩放等操作影响显示
        this.myChart.clear();
      } else { // 没有数据，初始化页面
        // 初始化统计图对象
        this.myChart = markRaw(echarts.init(this.$refs.chartsDOM));
      }
      // 显示 loading 动画
      this.myChart.showLoading();
      geoApi.getGeo(adCode).then(res => {
        this.geoDataList = res.features;
        this.adCode = adCode;
        // 得到结果后，关闭动画
        this.myChart.hideLoading();
        // 注册地图(数据放在axios返回对象的data中哦)
        echarts.registerMap(`ch_${adCode}`, res);
        this.refreshEcharts(adCode); // 重新渲染图表
      })
    },
    // 刷新图表显示，重新渲染
    refreshEcharts(adCode) {
      let option = {
        title: {
          text: ''
        },
        // 视觉组件，用这个来设置不同区域的颜色
        visualMap: {
          type: 'continuous', // 连续型渐变
          min: 0,
          max: 100,
          itemWidth: 0, // 标尺的宽度，0为不显示
          inRange: {
            color: ['#ffecb3', '#ff8a65', '#d81b60'] // 从浅黄到深红
          },
          calculable: true, // 显示拖拽手柄
          show: true
        },
        tooltip: {},
        series: [
          {
            name: '数据统计',
            type: 'map',
            map: `ch_${adCode}`,// 这个是上面注册时的名字哦，registerMap（'这个名字保持一致'）
            roam: "zoom",
            roamTrigger: "global",
            clip: true,
            label: {
              show: true
            },
            // 默认样式
            itemStyle: {
              areaColor: '#e0f7fa', // 默认区域颜色
              borderColor: '#81d4fa', // 边框颜色
              shadowColor: 'rgba(0, 0, 0, 0.5)', // 阴影颜色
            },
            // 鼠标悬停样式
            emphasis: {
              itemStyle: {
                areaColor: '#4fc3f7', // 鼠标悬停时的颜色
              }
            },
            // 选中样式
            select: {
              itemStyle: {
                areaColor: '#e0f7fa',
              }
            },
            data: [
              // {name: '北京市', value: 80}, // 这个用于不同区域显示不同颜色
              // {name: '上海市', value: 60},
              // {name: '广东省', value: 40},
              // {name: "四川省", value: 100}
            ],
            markPoint: {
              data: this.markerList
            }
          },
        ]
      };
      this.myChart.setOption(option);
    },
    // 地图点击事件,data: {name:'北京市'}
    chartClick(data) {
      let name = data.name;
      // 找到对应的数据
      for (let i = 0; i < this.geoDataList.length; i++) {
        if (name === this.geoDataList[i].properties.name) {
          if (this.geoDataList[i].properties.childrenNum > 0) { // 有下级的时候，下转
            this.showMap(this.geoDataList[i].properties.adcode);
          }
        }
      }
    },
    getData() {
      return new Promise(resolve => {
        setTimeout(() => {
          let res = {
            data: []
          }
          resolve(res);
        }, 5000);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.echart-map {
  height: 100%;
  position: relative;
  overflow: hidden;

  .map-container {
    height: 100%;
  }
  .site-info{
    position: absolute;
    width: 350px;
    height: 260px;
    top: 0;
    right: 0;
    //opacity: 1;
    // 显示动画
    transition: all ease-in-out .5s;
    &.hide{
      right: -350px;
      //opacity: 0;
    }
  }
  .site-info-item{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .info-line{
      display: flex;
      align-items: start;
      justify-content: space-between;
      .info-name{
        width: 65px;
      }
      .info-value{
        flex: 1;
      }
    }
    .info-button{
      text-align: right;
    }
  }

}
</style>